// extracted by mini-css-extract-plugin
export var circle = "_fr-1";
export var exitConfirmationModal = "_fr-5";
export var iframe = "_fr-0";
export var offline = "_fr-3";
export var online = "_fr-2";
export var workstationSelectError = "_fr-4";